import slide1 from '/src/assets/images/slider/slide-banner-1.png';
import slide2 from '/src/assets/images/slider/slide-banner-2.png';
import slide3 from '/src/assets/images/slider/slide-banner-3.png';
import googlePlay from "/src/assets/google-play.svg";
import appStore from "/src/assets/app-store.svg";


export const slider = {
    data: [
        {
            id: 1,
            title: "Paga y cobra </br> sin efectivo",
            subtitle: "<p>Resuélvelo todo en un toke, con tu número de celular o código QR</p>",
            imageContent: slide1,
            link: "Descárgala aquí",
            url: "www.prueba.com",
            stores: [
                {
                    type: "google-play",
                    image: googlePlay,
                    alt: "Disponible en Google Play",
                    link: "https://play.google.com/store/apps/details?id=com.popular.app.android&pli=1"
                },
                {
                    type: "app-store",
                    image: appStore,
                    alt: "Disponible en App Store",
                    link: "https://apps.apple.com/us/app/banco-popular-dominicano/id583475424"
                }
            ]
        },
        {
            id: 2,
            title: "Tu número celular </br> es tu cuenta",
            subtitle: "<p>Si te van a pagar, dales tu número de celular y que te den un toke</p>",
            imageContent: slide2,
            link: "Descárgala aquí",
            url: "www.prueba.com",
            layoutChange: true
        },
        {
            id: 3,
            title: "Tu negocio crece </br> con cada toke",
            subtitle: "<p>Olvídate del efectivo y que te paguen en un toke, no hay excusas.</p>",
            imageContent: slide3,
            link: "Más información",
            url: "#negocio-1",
        }
    ]
};
